module.exports = {"term_agreement_by_ll_owner":"Các điều khoản Thỏa thuận của Chủ nhà/Chủ sở hữu tài sản"};